import ApiManager from '../../utils/ApiManager'
import _ from 'lodash'

const state = {
  initLoaded: false,
  list: {
    loading: false,
    rowsPerPage: 20,
    totalItems: 0,
    headers: [
      { text: '分析名', align: 'left', value: 'analyze_target_name' },
      { text: 'メモ', align: 'left', value: 'memo', format: true },
      { text: 'ダッシュボード', align: 'left', value: 'dashboard_flag' },
      { text: '分析頻度', align: 'left', value: 'frequency' },
      { text: '次回分析日時', align: 'left', value: 'next_batch_date' },
      { text: '共有設定', align: 'left', value: 'publish_setting' },
      { text: '編集', align: 'left', value: '', type: 'edit', sortable: false }
    ],
    items: []
  }
}

const actions = {
  /**
   * 分析予約一覧データ取得
   */
  async getReservationList ({ state, commit }, { pageNo, sortField, sortType, freeword }) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Reservation').reservationList(
      pageNo,
      state.list.rowsPerPage,
      sortField,
      sortType,
      freeword
    )
    commit('setList', response.data)
  },
  /**
   * 分析予約更新
   */
  async doUpdate ({ state, commit }, editData) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Reservation').reservationEdit(
      {
        id: editData.id,
        publish_setting: parseInt(editData.publishSetting),
        dashboard_flag: parseInt(editData.dashboardFlag),
        memo: editData.memo
      }
    )
    if (response.data.code === 200000) {
      editData.response = response.data
      commit('afterUpdated', editData)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  /**
   * 分析予約削除
   */
  async doDelete ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Reservation').reservationDelete(deleteIds)
    if (response.data.code === 200000) {
      commit('afterDeleted', deleteIds)
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  }

}

const mutations = {
  init (state, data) {
    // 初期ローディングの終了
    state.initLoaded = true
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterUpdated (state, data) {
    let index = _.findIndex(state.list.items, function (o) { return o.id === data.id })
    let reservation = state.list.items[index]
    reservation.memo = data.memo
    reservation.publish_setting = (data.publishSetting === '1' ? 'Public' : 'Private')
    reservation.dashboard_flag = (data.dashboardFlag === '0' ? '表示しない' : '表示する')
    state.list.items[index] = reservation
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterDeleted (state, data) {
    this.dispatch('loading/loadingPageMinus')
    this.dispatch('pagereservationlist/getReservationList', {
      pageNo: 1,
      sortField: null,
      sortType: null
    })
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
